(function ($) {

  $(document).on('pjax:end', function (event, xhr, options) {
    /**
     * „An array of img elements you'd like picturefill to evaluate. The Default value for options.elements is all img
     * elements in the page that have a srcset attribute or have a picture element as a direct parent.“
     *
     * @see https://scottjehl.github.io/picturefill/#api
     */
    var elements = [];

    $(options.container).find('img[srcset], picture > img').each(function () {
      elements.push(this);
    });

    picturefill({
      elements: elements
    })
  });

  picturefill();

})(window.jQuery);
